import React from 'react';
import { Info, CheckCircle } from '@phosphor-icons/react';
import parse from 'html-react-parser';

interface Props {
  points: string[];
  isInfo?: boolean;
}

const InfoPoints: React.FC<Props> = (props) => {
  const { points, isInfo } = props;

  return (
    <div className="flex flex-col gap-2">
      {points.map((point: string, index: number) => {
        return (
          <div className="flex flex-row items-center gap-4" key={index}>
            {isInfo ? (
              <Info
                weight="fill"
                color="var(--blue-green-color)"
                size="1.5rem"
              />
            ) : (
              <CheckCircle
                weight="fill"
                color="var(--success-color)"
                size="1.5rem"
              />
            )}

            <div className="max-w-[calc(100%_-_2.5rem)]">{parse(point)}</div>
          </div>
        );
      })}
    </div>
  );
};

export default InfoPoints;
